import { useQuery } from "@tanstack/react-query";
import { okrService } from "@/services/okrService";

export const useOkrCycles = () => {
  return useQuery({
    queryKey: ["okr-cycles"],
    queryFn: () => okrService.getOkrCycles(),
  });
};
